import { useEffect, useState } from 'react';

import NotificationsCount from '@features/notifications/components/NotificationsCount/NotificationsCount';
import NotificationsModal from '@features/notifications/components/NotificationsModal/NotificationsModal';
import { useGetNotifications } from '@features/notifications/hooks/useGetNotifications';
import { Application } from '@features/applications';
import ScheduledInterviewModal from '@features/applicant/components/ScheduledInterviewModal/ScheduledInterviewModal';
import JobOfferResponse from '@features/applicant/components/JobOfferResponse/JobOfferResponse';
import JobOfferAcceptedModal from '@features/applicant/components/JobOfferAcceptedModal/JobOfferAcceptedModal';
import GetJobSuccessModal from '@features/applicant/components/GetJobSuccessModal/GetJobSuccessModal';
import MessagingModal from '@features/messaging/components/MessagingModal/MessagingModal';
import WotcSurveyCompleteCongratulationsModal from '@features/WotcSurvey/WotcSurveyCompleteContratulationsModal';
import { getCookie, setCookie } from '@utils/getCookie';
import { Notification } from '@features/notifications';

const Notifications = () => {
  const [isNotificationsModalOpen, setIsNotificationsModalOpen] =
    useState(false);
  const [selectedNotificationApplication, setSelectedNotificationApplication] =
    useState<Application | null>(null);
  const [isScheduledInterviewModalOpen, setIsScheduledInterviewModalOpen] =
    useState(false);

  const [isResponseJobOfferModalOpen, setIsResponseJobOfferModalOpen] =
    useState(false);
  const [isShowAcceptAccessModal, setShowAcceptAccessModal] = useState(false);
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [isGetSuccessModal, setIsGetSuccessModal] = useState(false);
  const [isMessagingModalOpen, setIsMessagingModalOpen] = useState(false);
  const [congratulationsModal, setCongratulationsModal] = useState(false);
  const isNotificationPopupShown = getCookie('isNotificationPopupShown');

  const handleNotificationClick = (application: Application) => {
    setSelectedNotificationApplication(application);
    setIsScheduledInterviewModalOpen(true);
  };

  const handlePendingJobOfferNotificationClick = (application: Application) => {
    setSelectedNotificationApplication(application);
    setIsResponseJobOfferModalOpen(true);
  };

  const hanldeOpenThreads = (application: Application) => {
    setSelectedNotificationApplication(application);
    setIsMessagingModalOpen(true);
  };

  const { notificationsData, isNotificationsFetched } = useGetNotifications();

  const readNotificationIds = new Set(
    notifications.filter((n) => n.is_read).map((n) => n.id),
  );

  useEffect(() => {
    if (notificationsData?.object?.length) {
      const updatedNotifications = notificationsData?.object
        ?.filter((en: Notification) => !readNotificationIds.has(en.id))
        .map((notification: Notification) => ({
          ...notification,
          is_read: false,
        }));

      if (!isNotificationPopupShown) {
        setCookie('isNotificationPopupShown', 'true', 1);
        setIsNotificationsModalOpen(true);
      }

      setNotifications(updatedNotifications);
    } else if (
      isNotificationsFetched &&
      notificationsData?.object?.length === 0
    ) {
      setNotifications([]);
    }
  }, [isNotificationsFetched, notificationsData, isNotificationPopupShown]);

  return (
    <>
      <NotificationsCount
        numberOfNotifications={
          notifications?.filter((item) => !item.is_read)?.length || 0
        }
        handleClick={() => setIsNotificationsModalOpen(true)}
      />
      <NotificationsModal
        isOpen={isNotificationsModalOpen}
        setCongratulationsModal={setCongratulationsModal}
        handleNotificationClick={handleNotificationClick}
        handlePendingJobOfferNotificationClick={
          handlePendingJobOfferNotificationClick
        }
        hanldeOpenThreads={hanldeOpenThreads}
        handleClose={() => setIsNotificationsModalOpen(false)}
        notifications={notifications?.filter((item) => !item.is_read) || []}
        setNotifications={setNotifications}
      />

      {isResponseJobOfferModalOpen && selectedNotificationApplication && (
        <JobOfferResponse
          isOpen={isResponseJobOfferModalOpen}
          handleClose={() => setIsResponseJobOfferModalOpen(false)}
          application={selectedNotificationApplication}
          setShowAcceptAccessModal={setShowAcceptAccessModal}
          setIsGetSuccessModal={setIsGetSuccessModal}
        />
      )}

      {isShowAcceptAccessModal && selectedNotificationApplication && (
        <JobOfferAcceptedModal
          isOpen={isShowAcceptAccessModal}
          handleClose={() => setShowAcceptAccessModal(false)}
          companyName={
            selectedNotificationApplication?.job_listing?.company?.s_name
          }
        />
      )}

      {isGetSuccessModal && selectedNotificationApplication && (
        <GetJobSuccessModal
          isOpen={isGetSuccessModal}
          handleClose={() => setIsGetSuccessModal(false)}
          application={selectedNotificationApplication}
          setIsMessagingModalOpen={setIsMessagingModalOpen}
        />
      )}

      {isMessagingModalOpen && selectedNotificationApplication && (
        <MessagingModal
          isOpen={isMessagingModalOpen}
          handleClose={() => setIsMessagingModalOpen(false)}
          application={selectedNotificationApplication}
        />
      )}

      {isScheduledInterviewModalOpen && selectedNotificationApplication && (
        <ScheduledInterviewModal
          isOpen={isScheduledInterviewModalOpen}
          handleClose={() => {
            setIsScheduledInterviewModalOpen(false);
            setSelectedNotificationApplication(null);
          }}
          application={selectedNotificationApplication}
          slots={
            selectedNotificationApplication.calendar_block_invite ? true : false
          }
        />
      )}
      {congratulationsModal && (
        <WotcSurveyCompleteCongratulationsModal
          congratulationsModal={congratulationsModal}
          handleClose={() => {
            setCongratulationsModal(false);
          }}
        />
      )}
    </>
  );
};

export default Notifications;
